import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#4CC75B",
      light: "#8EE598",
      dark: "#238E38",
      contrastText: "#102416",
      lighterShade: "#E3F8E6",
    },
    secondary: { main: "#D62E69" },
    background: { default: "#F6F8F7", paper: "#FFFFFF" },
    text: { primary: "#17251C", secondary: "#617066" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    h4: { fontWeight: 750, letterSpacing: "-0.03em" },
    h5: { fontWeight: 700, letterSpacing: "-0.02em" },
    h6: { fontWeight: 700 },
    button: { fontWeight: 700, letterSpacing: 0, textTransform: "none" },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: { backgroundColor: "#F6F8F7" },
        "*": { boxSizing: "border-box" },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: "#FFFFFF",
          color: "#17251C",
          boxShadow: "0 1px 0 rgba(23, 37, 28, 0.10)",
        },
      },
    },
    MuiToolbar: { styleOverrides: { root: { minHeight: "64px !important" } } },
    MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
    MuiCard: {
      styleOverrides: {
        root: {
          border: "1px solid #E2EAE4",
          boxShadow: "0 2px 10px rgba(19, 46, 29, 0.05)",
          borderRadius: 16,
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: { minHeight: 38, paddingInline: 16 },
        containedPrimary: {
          boxShadow: "0 2px 5px rgba(35, 142, 56, 0.22)",
          "&:hover": {
            backgroundColor: "#36AB4C",
            boxShadow: "0 4px 10px rgba(35, 142, 56, 0.28)",
          },
        },
        outlinedPrimary: {
          borderColor: "#238E38",
          color: "#176B2A",
          "&:hover": { backgroundColor: "#E3F8E6", borderColor: "#176B2A" },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& :-webkit-autofill": {
            WebkitBoxShadow: "0 0 0 1000px white inset",
            WebkitTextFillColor: "#17251C",
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: { color: "#526158", fontWeight: 700, backgroundColor: "#F6F8F7" },
        root: { borderColor: "#E8EEEA" },
      },
    },
    MuiTabs: { styleOverrides: { indicator: { height: 3, borderRadius: 3 } } },
  },
});

export const ViewOnlyPages = createTheme(theme, {
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiInputLabel-root.Mui-disabled": { color: "#617066" },
          "& .MuiInputBase-input.Mui-disabled": {
            WebkitTextFillColor: "#17251C",
          },
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: { "&.Mui-disabled": { WebkitTextFillColor: "#17251C" } },
      },
    },
    MuiCheckbox: {
      styleOverrides: { root: { "&.Mui-disabled": { color: "#238E38" } } },
    },
  },
});

export default theme;
